import { resolvers } from './resolvers';
import {
  ApolloClient,
  ApolloLink,
  from,
  NormalizedCacheObject,
  InMemoryCache,
  createHttpLink,
} from '@apollo/client';
import {
  clientVersion,
  atlassianGraphQLUrl,
  trelloGraphQLUrl,
} from '@trello/config';
import typeDefs from './schema';
import { typePolicies } from './typePolicies';
import { getInvitationTokens } from '@trello/session-cookie';
import { DocumentNode } from 'graphql';
import { allowedAtlassianFields } from './allowedAtlassianFields';

// eslint-disable-next-line @trello/no-module-logic
const sendToAtlassian = new ApolloLink((operation, forward) => {
  let hasAtlassianSelection = false;
  let hasTrelloSelection = false;

  operation.query.definitions.forEach((definition) => {
    if (definition.kind === 'OperationDefinition') {
      definition.selectionSet.selections.forEach((selection) => {
        if (selection.kind === 'Field') {
          if (allowedAtlassianFields.Query.includes(selection.name.value)) {
            hasAtlassianSelection = true;
          } else {
            hasTrelloSelection = true;
          }
        }
      });
    }
  });

  if (
    hasAtlassianSelection &&
    hasTrelloSelection &&
    process.env.NODE_ENV !== 'production'
  ) {
    throw new Error(
      'Querying data from Atlassian GraphQL Gateway and Trello GraphQL in the same query is not currently supported. Please split the query.',
    );
  }

  if (hasAtlassianSelection) {
    operation.setContext({
      uri: atlassianGraphQLUrl,
    });
  }
  return forward(operation);
});

// eslint-disable-next-line @trello/no-module-logic
const sendToTrello = createHttpLink({
  uri: trelloGraphQLUrl,
  credentials: 'include',
});

// eslint-disable-next-line @trello/no-module-logic
export const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  // eslint-disable-next-line @trello/no-module-logic
  cache: new InMemoryCache({ typePolicies }),
  // eslint-disable-next-line @trello/no-module-logic
  link: from([sendToAtlassian, sendToTrello]),
  name: 'trello-web',
  version: clientVersion,
  resolvers,
  typeDefs: typeDefs as DocumentNode,
  defaultOptions: {
    query: {
      context: {
        // eslint-disable-next-line @trello/no-module-logic
        invitationTokens: getInvitationTokens(),
      },
    },
  },
  ...(process.env.NODE_ENV === 'development' && { connectToDevTools: true }),
});
